export default __webpack_public_path__ + "static/media/imone-img.6657856e.webp";